import React, {useEffect, useMemo, useState} from 'react';
import {Checkbox, FormControlLabel, FormGroup, Stack} from '@mui/material';
import PropTypes from 'prop-types';
import AdmicityDialog from '../../../../shared-components/AdmicityDialog';
import {orderStudentColumns, studentColumnsOfferedToSchool} from './studentColumnOptions';

const StudentColumnsDialog = ({open, format, school, onClose, onDownload}) => {
    const [chosen, setChosen] = useState([]);

    const options = useMemo(() => studentColumnsOfferedToSchool(school), [school]);

    useEffect(() => {
        if (open) {
            setChosen([]);
        }
    }, [open]);

    const toggle = key => setChosen(previous => previous.includes(key)
        ? previous.filter(chosenKey => chosenKey !== key)
        : [...previous, key]);

    return (
        <AdmicityDialog
            open={open}
            handleClose={onClose}
            title={`Download ${format}`}
            maxWidth="sm"
            actions={[
                {
                    label: 'Cancel',
                    onClick: onClose
                },
                {
                    label: 'Download',
                    onClick: () => onDownload(orderStudentColumns(chosen))
                }
            ]}
        >
            <Stack sx={{mt: 1}}>
                <FormGroup>
                    {options.map(option => (
                        <FormControlLabel
                            key={option.key}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={chosen.includes(option.key)}
                                    onChange={() => toggle(option.key)}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </FormGroup>
            </Stack>
        </AdmicityDialog>
    );
};

StudentColumnsDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    format: PropTypes.string.isRequired,
    school: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired
};

export default StudentColumnsDialog;
